import smgActivityLog from '@/api/customer-service/smg-activity-log'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: [],
  branch_id: [],
  module: 'all',
  status: 'all',
  action: 'all',
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_MODULE(state, value) {
    state.module = value
  },
  SET_STATUS(state, value) {
    state.status = value
  },
  SET_ACTION(state, value) {
    state.action = value
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          // branch_id: context.state.branch_id,
          search: context.state.search,
          module: context.state.module,
          status: context.state.status,
          action: context.state.action,
        }
      },
      attrubutes
    )
    return smgActivityLog.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async getFormViewModel(context, { params, index }) {
    let response = await smgActivityLog.formViewModel({ params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },
}
